import React, { useState } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
  FormControl,
  NativeSelect,
  InputBase,
  TextField,
  CircularProgress,
  Button,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { palette, useStylesGlobal } from "configurations/styles/theme";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import { tipoContribuyente } from "./typeVoucher";
import { useSelector } from "react-redux";
import {
  API_GET_ALL_CORREGIMIENTOS,
  API_GET_ALL_DISTRITOS,
  API_GET_ALL_PROVINCIAS,
} from "views/administración/providers/apis";
import clientBackend from "configurations/axios";
import { validationDeliveryLocationInvoice } from "./Validations/validationsForms";
import { useSnackbar } from "notistack";
import { useStylesApp } from "hooks/useStyles";
const BootstrapInput = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(0),
    },
  },
  input: {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #ced4da",
    fontSize: 16,
    padding: "10px 26px 10px 12px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      borderRadius: 4,
      borderColor: "#80bdff",
      boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
    },
  },
}))(InputBase);
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    marginBottom: "0.5%",
  },
  heading: {
    fontSize: theme.typography.pxToRem(14),
    fontWeight: theme.typography.fontWeightRegular,
    color: palette.primary.menuHeader,
  },
  accordionSumary: {
    backgroundColor: palette.primary.light,
  },
  margin: {
    margin: theme.spacing(0),
    width: "100%",
    marginBottom: "1%",
  },
  formControl: {
    marginTop: theme.spacing(0),
    minWidth: 120,
  },
  radio: {
    display: "-webkit-box",
    marginTop: "0px",
  },
  radioLable: {
    color: palette.primary.main,
    display: "flex",
  },
  radioButton: {
    marginTop: "0px",
    paddingTop: "0px",
  },
  divForm: {
    marginBottom: "1%",
  },
  divInput: {
    marginBottom: "1%",
    paddingRight: "1%",
    paddingLeft: "0.5%",
  },
  divButton: {
    paddingLeft: "3%",
    paddingRight: "3%",
  },
  backdrop: {
    zIndex: theme.zIndex.modal + 999,
    color: palette.primary.main,
  },
}));

const IdentificationDeliveryLocation = ({
  informationDeliveryPlace,
  setInformationDeliveryPlace,
}) => {
  const classesGlobal = useStylesGlobal();
  const { enqueueSnackbar } = useSnackbar();
  const classesApp = useStylesApp();
  const [open, setOpen] = useState(false);
  const userToken = useSelector((state) => state.user.tk);
  const [msgError, setMsg] = useState({ show: false, msg: null, type: null });
  const [errors, setErrors] = useState({});
  const [rucAutorizado, setRucAutorizado] = useState({
    dv: "",
    ruc: "",
    tipoRuc: "",
  });
  const [deliveryPlace, setDeliveryPlace] = useState({});
  const classes = useStyles();
  //PROVINCIA
  const [provincia, setProvincia] = useState([]);
  const [loadProvincia, setLoadProvincia] = useState(true);
  const [selectedProvicia, setSelectedProvincia] = useState({
    idUbicacionGeografica: "",
  });
  //DISTRITO
  const [distrito, setDistrito] = useState([]);
  const [loadDistrito, setLoadDistrito] = useState(true);
  const [selectedDistrito, setSelectedDistrito] = useState({
    idUbicacionGeografica: "",
  });
  //CORREGIMIENTO
  const [corregimiento, setCorregimiento] = useState([]);
  const [loadCorregimiento, setLoadCorregimiento] = useState(true);
  const [selectedCorregimiento, setSelectedCorregimiento] = useState({
    idUbicacionGeografica: "",
  });

  const handleChange = (event) => {
    setDeliveryPlace({
      ...deliveryPlace,
      [event.target.name]: event.target.value,
    });
  };

  const handleChangeRuc = (event) => {
    setRucAutorizado({
      ...rucAutorizado,
      [event.target.name]: event.target.value,
    });
  };

  const validateLocalInformation = (data, rucAuthorized) => {
    let newErrors = validationDeliveryLocationInvoice.onSubmit({
      nombreLocalEntrega: data.nombreLocalEntrega,
      provincia: data.provincia,
      distrito: data.distrito,
      corregimiento: data.corregimiento,
      tipoRuc: rucAuthorized.tipoRuc,
      ruc: rucAuthorized.ruc,
      dv: rucAuthorized.dv,
      direccionLocalEntrega: data.direccionLocalEntrega,
      telefonoLocalEntrega: data.telefonoLocalEntrega,
      telefonoAdicionalLocalEntrega: data.telefonoAdicionalLocalEntrega,
    });
    if (Object.entries(newErrors).length > 0) {
      setErrors(newErrors);
      return false;
    } else {
      return true;
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
    setMsg({ show: false, msg: null, type: null });
    setLoadProvincia(true);
    setSelectedProvincia({ ubicacionGeografica: "" });
    setSelectedDistrito({ ubicacionGeografica: "" });
    setSelectedCorregimiento({ ubicacionGeografica: "" });
  };

  const getProvicias = async (token) => {
    setLoadProvincia(false);
    if (open) {
      await clientBackend
        .get(API_GET_ALL_PROVINCIAS)
        .then((result) => {
          if (result.status === 200) {
            let provincias = result.data;
            for (let i = 0; i < provincias.length; i++) {
              provincias[i].label = provincias[i].nombre;
            }
            setProvincia(provincias);
          }
        })
        .catch((exception) => {
          setProvincia([{ label: "Error al cargar las provincias" }]);
          setMsg({
            show: true,
            msg: "Ocurrió un problema al cargar las provincias.",
          });
        });
    }
  };

  const renderProvincias = () => {
    if (provincia.length === 0 && userToken && loadProvincia) {
      getProvicias(userToken);
    }
    return (
      <Autocomplete
        value={selectedProvicia}
        onChange={(event, newValue) => {
          setSelectedProvincia(newValue);
          setLoadDistrito(true);
          if (newValue != null) {
            setDeliveryPlace((deliveryPlace) => ({
              ...deliveryPlace,
              provincia: newValue.nombre,
            }));
            getDistrito(newValue.idUbicacionGeografica);
          } else {
            setDeliveryPlace((deliveryPlace) => ({
              ...deliveryPlace,
              provincia: "",
            }));
          }
        }}
        options={provincia}
        getOptionLabel={(option) => option.label}
        style={{ width: "95%" }}
        loading={provincia.length === 0}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            label="Lista de provincias"
            classes={{ root: classes.textFieldComboBox }}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {provincia.length === 0 ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
    );
  };

  const getDistrito = async (provinciaSelected) => {
    setLoadDistrito(false);
    if (open) {
      await clientBackend
        .get(API_GET_ALL_DISTRITOS + "/" + provinciaSelected)
        .then((result) => {
          if (result.status === 200) {
            let distritos = result.data;
            for (let i = 0; i < distritos.length; i++) {
              distritos[i].label = distritos[i].nombre;
            }
            setDistrito(distritos);
          }
        })
        .catch((exception) => {
          setDistrito([{ label: "Error al cargar los distritos" }]);
          setMsg({
            show: true,
            msg: "Ocurrió un problema al cargar los distritos.",
          });
        });
    }
  };

  const renderDistritos = () => {
    return (
      <Autocomplete
        value={selectedDistrito}
        onChange={(event, newValue) => {
          setSelectedDistrito(newValue);
          setLoadDistrito(true);
          if (newValue != null) {
            setDeliveryPlace((deliveryPlace) => ({
              ...deliveryPlace,
              distrito: newValue.nombre,
            }));
            getCorregimientos(
              selectedProvicia.idUbicacionGeografica,
              newValue.idUbicacionGeografica
            );
          } else {
            setDeliveryPlace((deliveryPlace) => ({
              ...deliveryPlace,
              distrito: "",
            }));
          }
        }}
        options={distrito}
        getOptionLabel={(option) => option.label}
        style={{ width: "95%" }}
        loading={distrito.length === 0}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            label="Lista de distritos"
            classes={{ root: classes.textFieldComboBox }}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {distrito.length === 0 ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
    );
  };

  const getCorregimientos = async (provinciaSelected, distritoSelected) => {
    setLoadCorregimiento(false);
    if (open) {
      await clientBackend
        .get(
          API_GET_ALL_CORREGIMIENTOS +
            "/" +
            provinciaSelected +
            "/" +
            distritoSelected
        )
        .then((result) => {
          if (result.status === 200) {
            let corregimientos = result.data;
            for (let i = 0; i < corregimientos.length; i++) {
              corregimientos[i].label = corregimientos[i].nombre;
            }
            setCorregimiento(corregimientos);
          }
        })
        .catch((exception) => {
          setCorregimiento([{ label: "Error al cargar los corregimientos" }]);
          setMsg({
            show: true,
            msg: "Ocurrió un problema al cargar los corregimientos.",
          });
        });
    }
  };

  const renderCorregimiento = () => {
    return (
      <Autocomplete
        value={selectedCorregimiento}
        onChange={(event, newValue) => {
          setSelectedCorregimiento(newValue);
          if (newValue != null) {
            setDeliveryPlace((deliveryPlace) => ({
              ...deliveryPlace,
              corregimiento: newValue.nombre,
              codigoUnificado: newValue.secuencial,
            }));
            let concatenado =
              deliveryPlace.provincia +
              "-" +
              deliveryPlace.distrito +
              "-" +
              newValue.nombre;
            setDeliveryPlace((deliveryPlace) => ({
              ...deliveryPlace,
              ubicacionGeografica: concatenado,
            }));
          } else {
            setDeliveryPlace((deliveryPlace) => ({
              ...deliveryPlace,
              corregimiento: "",
            }));
          }
        }}
        options={corregimiento}
        getOptionLabel={(option) => option.label}
        style={{ width: "95%" }}
        loading={corregimiento.length === 0}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            label="Lista de corregimientos"
            classes={{ root: classes.textFieldComboBox }}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {corregimiento.length === 0 ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
    );
  };

  const handleClickAdd = () => {
    if (validateLocalInformation(deliveryPlace, rucAutorizado)) {
      setInformationDeliveryPlace({
        ...deliveryPlace,
        rucContribuyenteReceptor: rucAutorizado,
      });
      enqueueSnackbar(
        `Información del local de entrega agregada al comprobante`,
        {
          variant: "success",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          autoHideDuration: 4000,
        }
      );
      setErrors({});
    }
  };

  return (
    <div className={classes.root}>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          onClick={handleClickOpen}
        >
          <label className={classesGlobal.titleCard}>
            Información del Local de Entrega:{" "}
          </label>
          <label className={classesGlobal.click}>
            <label> </label> (Clic Aquí)
          </label>
        </AccordionSummary>
        <AccordionDetails>
          <from style={{ width: "100%" }}>
            <Grid
              container
              xs={12}
              md={12}
              direction="row"
              justifyContent="center"
              alignItems="center"
              spacing={1}
            >
              <Grid item xs={12} md={2}>
                <label>Nombre o razón social:</label>{" "}
                <font color={palette.error.main}>*</font>
              </Grid>
              <Grid item xs={12} md={4}>
                <input
                  type="string"
                  className="form-control"
                  name="nombreLocalEntrega"
                  value={deliveryPlace.nombreLocalEntrega}
                  onChange={handleChange}
                />
                {errors.nombreLocalEntrega ? (
                  <p className={classesApp.errorLetters}>
                    {errors.nombreLocalEntrega}
                  </p>
                ) : null}
              </Grid>
              <Grid item xs={12} md={2}>
                <label>RUC:</label> <font color={palette.error.main}>*</font>
              </Grid>
              <Grid item xs={12} md={4}>
                <input
                  type="string"
                  className="form-control"
                  name="ruc"
                  value={rucAutorizado.ruc}
                  onChange={handleChangeRuc}
                />
                {errors.ruc ? (
                  <p className={classesApp.errorLetters}>{errors.ruc}</p>
                ) : null}
              </Grid>
              <Grid item xs={12} md={2}>
                <label>Tipo de contribuyente:</label>{" "}
                <font color={palette.error.main}>*</font>
              </Grid>
              <Grid item xs={12} md={4} className={classes.divInput}>
                <FormControl className={classesGlobal.select}>
                  <NativeSelect
                    value={rucAutorizado.tipoRuc}
                    name="tipoRuc"
                    onChange={handleChangeRuc}
                    input={<BootstrapInput />}
                  >
                    <option aria-label="None" value="">
                      --Seleccione--
                    </option>
                    {tipoContribuyente.map((element) => (
                      <option key={element.CODIGO} value={element.CODIGO}>
                        {element.NOMBRE}
                      </option>
                    ))}
                  </NativeSelect>
                </FormControl>
                {errors.tipoRuc ? (
                  <p className={classesApp.errorLetters}>{errors.tipoRuc}</p>
                ) : null}
              </Grid>
              <Grid item xs={12} md={2}>
                <label>Dígito verificador:</label>{" "}
                <font color={palette.error.main}>*</font>
              </Grid>
              <Grid item xs={12} md={4}>
                <input
                  type="string"
                  className="form-control"
                  name="dv"
                  value={rucAutorizado.dv}
                  onChange={handleChangeRuc}
                />
                {errors.dv ? (
                  <p className={classesApp.errorLetters}>{errors.dv}</p>
                ) : null}
              </Grid>
              <Grid item xs={12} md={2}>
                <label>Dirección del local de entrega:</label>{" "}
                <font color={palette.error.main}>*</font>
              </Grid>
              <Grid item xs={12} md={4}>
                <input
                  type="string"
                  className="form-control"
                  name="direccionLocalEntrega"
                  value={deliveryPlace.direccionLocalEntrega}
                  onChange={handleChange}
                />
                {errors.direccionLocalEntrega ? (
                  <p className={classesApp.errorLetters}>
                    {errors.direccionLocalEntrega}
                  </p>
                ) : null}
              </Grid>
              <Grid item xs={12} md={2}>
                <label>Provincia:</label>{" "}
                <font color={palette.error.main}>*</font>
              </Grid>
              <Grid item xs={12} md={4} className={classes.divInput}>
                {renderProvincias()}
                {errors.provincia ? (
                  <p className={classesApp.errorLetters}>{errors.provincia}</p>
                ) : null}
              </Grid>
              <Grid item xs={12} md={2}>
                <label>Distrito:</label>{" "}
                <font color={palette.error.main}>*</font>
              </Grid>
              <Grid item xs={12} md={4} className={classes.divInput}>
                {renderDistritos()}
                {errors.distrito ? (
                  <p className={classesApp.errorLetters}>{errors.distrito}</p>
                ) : null}
              </Grid>
              <Grid item xs={12} md={2}>
                <label>Corregimiento:</label>{" "}
                <font color={palette.error.main}>*</font>
              </Grid>
              <Grid item xs={12} md={4} className={classes.divInput}>
                {renderCorregimiento()}
                {errors.corregimiento ? (
                  <p className={classesApp.errorLetters}>
                    {errors.corregimiento}
                  </p>
                ) : null}
              </Grid>
              <Grid item xs={12} md={2}>
                <label>Teléfono principal:</label>
              </Grid>
              <Grid item xs={12} md={4}>
                <input
                  type="string"
                  className="form-control"
                  name="telefonoLocalEntrega"
                  value={deliveryPlace.telefonoLocalEntrega}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <label>Teléfono alterno:</label>
              </Grid>
              <Grid item xs={12} md={4}>
                <input
                  type="string"
                  className="form-control"
                  name="telefonoAdicionalLocalEntrega"
                  value={deliveryPlace.telefonoAdicionalLocalEntrega}
                  onChange={handleChange}
                />
              </Grid>
            </Grid>
          </from>
          <Button variant="outlined" color="primary" onClick={handleClickAdd}>
            Agregar local de entrega
          </Button>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default IdentificationDeliveryLocation;
